export const config = {
  title: "Eriks Roofing | Expert Roofing Services in North Carolina",
  meta: {
    description:
      "Eriks Roofing provides top-quality roofing services in North Carolina. Specializing in roof installation, repairs, siding, and window installations with exceptional craftsmanship.",
    keywords: [
      'Roofing Services NC',
      'Roof Installation',
      'Roof Repair',
      'Siding Installation',
      'Window Installation',
      'Gutter Services',
      'Eriks Roofing',
      'North Carolina Roofing Services',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Eriks Roofing",
    canonicalUrl: 'https://www.eriksroofing.com/',
  },
  sections: {
    header: {
      businessName: "Eriks Roofing",
    },
    sectionB: {
      heroTitle: "Eriks Roofing",
      heroSubtitle: 'Reliable & Professional Roofing Solutions',
      learnAboutText: 'Explore Services',
      phoneNumber: '3105908216',
      phoneLabel: '(310) 590-8216',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/2167986788/photo/construction-crew-putting-up-framing-of-new-home.jpg?s=612x612&w=0&k=20&c=PmoyuOSrfFNh7cCUUS8gkmcoQ24jhaOTSrShw_Buobc=',
      cardData: [
        {
          title: 'Roofing Services',
          description:
            'Expert roofing installation and repairs with premium materials for durability and protection.',
        },
        {
          title: 'Siding Installation',
          description:
            'Enhance your property’s exterior with top-quality siding solutions for improved aesthetics and insulation.',
        },
        {
          title: 'Window Installation',
          description:
            'Professional window installation services to improve energy efficiency and home aesthetics.',
        },
      ],
      description:
        "Eriks Roofing provides superior roofing services, including installation, siding, and window installations. Our expert team delivers high-quality craftsmanship to enhance the durability and aesthetics of your home.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Explore our extensive range of roofing services, tailored to meet residential and commercial needs.",
      cards: [
        {
          title: 'Roofing',
          description:
            'Professional roofing services, including installation and repairs. We speak English & Spanish.',
          imageSrc:
            'https://media.istockphoto.com/id/1264003590/photo/caulk-gun.jpg?s=612x612&w=0&k=20&c=cjZR_Kf0TZ48bJlMFWt9Hx15m4VPUsOdxU2Amc8od64=',
          imageAlt: 'Roofing Services',
        },
        {
          title: 'Siding',
          description:
            'High-quality siding solutions for enhanced durability and aesthetic appeal.',
          imageSrc:
            'https://media.istockphoto.com/id/172628686/photo/two-men-applying-green-paneling-to-a-house.jpg?s=612x612&w=0&k=20&c=fQr8PudOM3ZYFPIsIKcGeHUqQtZfUbIxQHjWyGnvBBA=',
          imageAlt: 'Siding Services',
        },
        {
          title: 'Windows',
          description:
            'Comprehensive window installation services for energy efficiency and home aesthetics.',
          imageSrc:
            'https://media.istockphoto.com/id/1369399520/photo/construction-worker-installing-window-in-house-handyman-fixing-the-window-with-screwdriver.jpg?s=612x612&w=0&k=20&c=V0yMjJaOWDY_CpuZjjAzAmW_c75999IePhuI0vwRiqg=',
          imageAlt: 'Window Installation Services',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Gutters',
        'Doors',
        'Restoration',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/1756791456/photo/young-homeowners-installing-solar-panels-on-a-suburban-western-usa-home.jpg?s=612x612&w=0&k=20&c=cjUb-WetsMOsO9Yu6sumsIlKBGzOQvpjiUDhVWWzHs4=',
        alt: "Eriks Roofing",
      },
      aboutText: [
        "If you are a property owner in North Carolina, you can trust our roofing expertise. Whether you need a new installation, repairs, or siding solutions, our experienced team is ready to help.",
        "With years of experience, we ensure that your home improvement projects meet the highest standards. Our team works closely with homeowners to create durable and aesthetically pleasing roofing and siding solutions.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Eriks Roofing Logo",
      businessName: "Eriks Roofing",
      contact: {
        phone: '3105908216',
        phoneLabel: '(310) 590-8216',
        email: 'eriksroofingcompany@gmail.com',
        website: 'https://www.eriksroofing.com/',
        address: 'NC 28214, US',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'NC 28214, US',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3156.18427904767!2d-80.970425!3d35.2643536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88542f34f0bdf77b%3A0x123456789abcdef!2sCharlotte%2C%20NC%2028214%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
